import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import Image from "next/image";
import styles from "./location-drop.module.css";
import { FaChevronDown } from 'react-icons/fa';

const options = [
  { name: "Tbilisi", value: "tbilisi", icon: <Image src="/assets/images/icons/location.svg" width={35} height={35} alt="Tbilisi" /> },
  { name: "Tbilisi Airport", value: "tbilisi-airport", icon: <Image src="/assets/images/icons/airplane.svg" width={35} height={35} alt="Tbilisi Airport" /> },
  { name: "Kutaisi", value: "kutaisi", icon: <Image src="/assets/images/icons/location.svg" width={35} height={35} alt="Kutaisi" /> },
  { name: "Kutaisi Airport", value: "kutaisi-airport", icon: <Image src="/assets/images/icons/airplane.svg" width={35} height={35} alt="Kutaisi Airport" /> },
  { name: "Batumi", value: "batumi", icon: <Image src="/assets/images/icons/location.svg" width={35} height={35} alt="Batumi" /> },
  { name: "Batumi Airport", value: "batumi-airport", icon: <Image src="/assets/images/icons/airplane.svg" width={35} height={35} alt="Batumi Airport" /> },
];

const LocationDrop = forwardRef(function LocationDrop({ current, onSelectOption }, ref) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(current || options[0].value);
  const dropRef = useRef(null);

  useEffect(() => {
    if (current && current !== selectedOption) {
      setSelectedOption(current);
    }
  }, [current]);

  useEffect(() => {
    const handleOutside = e => {
      if (dropRef.current && !dropRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  const toggleDropdown = () => setIsOpen(o => !o);
  useImperativeHandle(ref, () => ({
    toggle: toggleDropdown,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  }));

  const handleToggle = (e) => {
    e.stopPropagation();
    toggleDropdown();
  };

  const handleOptionClick = (opt, e) => {
    e.stopPropagation();
    setSelectedOption(opt.value);
    onSelectOption(opt.value);
    setIsOpen(false);
  };

  const customName = selectedOption
    ? String(selectedOption).split('-').filter(Boolean).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
    : '';
  const display = options.find(o => o.value === selectedOption)
    || (customName
      ? { name: customName, icon: <Image src="/assets/images/icons/location.svg" width={35} height={35} alt={customName} /> }
      : options[0]);

  return (
    <div
      className={styles.toggle}
      style={{ width: '100%' }}
      ref={dropRef}
      onClick={handleToggle}
    >
      <div className={styles.searchBarInputs} style={{ width: '100%' }}>
        {display.icon}
        <span className={styles.label}>{display.name}</span>
        <FaChevronDown
          className={`${styles.chevron} ${isOpen ? styles.open : ''}`}
          aria-hidden="true"
        />
      </div>

      {isOpen && (
        <div className={styles.dropdown}>
          {options.map((opt, i) => (
            <div
              key={i}
              className={styles.dropItem}
              onClick={e => handleOptionClick(opt, e)}
            >
              <div>{opt.icon}</div>
              <div>{opt.name}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
});

export default LocationDrop;
